import * as React from "react";
import { Container } from "../../Container";
import { Button } from "../../../components/Buttons";
import { DeleteObjectsActions } from "../../flux/DeleteObjects";
import { Polyglot } from "../../../polyglot";
import { SelectedItemsStore } from "../../flux/Grid";
import { EntityType } from "../../../models";

export interface TrashButtonProps<T>
{
    polyglot: Polyglot;
    entityType: EntityType;
    selectedItemsStore: SelectedItemsStore<T>;
}

// TrashButtonWidget is a styled button which is shown on every entity page which could be removed
// It is disabled if there are no selected entities
export class TrashButtonWidget<T> extends React.Component<TrashButtonProps<T>, any>
{
    private readonly deleteObjectsActions = new DeleteObjectsActions();

    shouldComponentUpdate(nextProps: Readonly<TrashButtonProps<T>>, nextState: Readonly<any>, nextContext: any)
    {
        return false;
    }
    
    render()
    {
        return (
            <Container merge stores={[
                [this.props.selectedItemsStore, (store: SelectedItemsStore<T>) => ({ disabled: store.getState().selected.size === 0 })]
            ]}>
                <Button leftIcon="trash" type="danger" className="pull-right"
                    title={this.props.polyglot.t('misc.btn_trash_title')}
                    onClick={() => {
                        const toDelete = [...this.props.selectedItemsStore.getState().selected];
                        this.deleteObjectsActions.setIds(toDelete, this.props.entityType);
                        this.deleteObjectsActions.showConfirmation(this.props.entityType);
                    }}
                />
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TrashButtonWidget/TrashButtonWidget.tsx